import { render, staticRenderFns } from "./copyWorkList.vue?vue&type=template&id=d720d1d0&scoped=true"
import script from "./copyWorkList.vue?vue&type=script&lang=js"
export * from "./copyWorkList.vue?vue&type=script&lang=js"
import style0 from "./copyWorkList.vue?vue&type=style&index=0&id=d720d1d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d720d1d0",
  null
  
)

export default component.exports